import { render } from "./Person.vue?vue&type=template&id=abda5890"
import script from "./Person.vue?vue&type=script&lang=js"
export * from "./Person.vue?vue&type=script&lang=js"

import "./Person.vue?vue&type=style&index=0&id=abda5890&lang=css"

import exportComponent from "D:\\xyzw\\springboot-vue-demo\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__